import Group from 'entities/group'
import Tag from 'entities/tag'
import { isEmpty } from 'lodash'
import moment from 'moment'

export default class Recruiter {
  constructor(object) {
    this.id = object.id || null
    this.name = object.name || null
    this.token = object.token || null
    this.tags = !isEmpty(object.tags) ? object.tags.map(t => new Tag(t)) : []
    this.group = object.group && Group.fromJson(object.group)
  }
}

export class RecruiterDetails {
  constructor(object) {
    this.id = object.id || null
    this.status = object.status || null
    this.lastName = object.last_name || null
    this.firstName = object.first_name || null
    this.email = object.email || null
    this.number = object.number || null
    this.phoneNumber = object.phone_number || null
    this.position = object.position || null
    this.groupId = parseInt(object && object.group_id, 10) || null
    this.tags = !isEmpty(object.tags) ? object.tags.map(t => new Tag(t)) : []
  }
}

export class RecruiterWithMetrics extends Recruiter {
  constructor(object) {
    super(object)
    this.position = object.position || null
    this.status = object.status || null
    this.cooperationsCount = object.cooperations_count
    this.applicantsCount = object.applicants_count
    this.hiredCount = object.hired_count
    this.lastLaunchedAt =
      object.last_launched_at === null ||
      typeof object.last_launched_at === 'undefined' ||
      object.last_launched_at === 0
        ? null
        : moment.unix(object.last_launched_at)
  }
}

export class RecruiterForCsvImport {
  constructor(object) {
    this.id = object.id || null
    this.status = object.status || null
    this.lastName = object.last_name || null
    this.firstName = object.first_name || null
    this.email = object.email || null
    this.number = object.number || null
    this.position = object.position || null
    this.group = object.group && Group.fromJson(object.group)
    this.tags = !isEmpty(object.tags) ? object.tags.map(t => new Tag(t)) : []
  }
}
